<template>
    <div v-if="loading" class="flex flex-column justify-content-center align-items-center">
        <h4 class="text-center">Loading...</h4>
        <ScaleLoader class="m-auto" />
    </div>

    <div v-if="!loading" class="card">
        <div class="grid">
            <div class="form-field col-3">
                <label for="name">User Group Name</label>
                <InputText
                    maxlength = "255"
                    v-model="userGroupModel.name"
                    id="name"
                    :disabled="readonly === true"
                    placeholder="Enter User Group name"
                />
            </div>
            <div class="form-field col-3">
                <label for="code">Code</label>
                <InputText
                    maxlength = "255"
                    v-model="userGroupModel.code"
                    id="code"
                    :disabled="readonly === true"
                    placeholder="Enter User Group code"
                />
            </div>
            <div class="form-field col-6">
                <label for="description">Description</label>
                <InputText
                    maxlength = "255"
                    v-model="userGroupModel.description"
                    id="description"
                    :disabled="readonly === true"
                    placeholder="Enter User Group description"
                />
            </div>

            <div class="form-field col-3">
                <label for="relative_date_unit">Relative Date type</label>
                <div class="flex overflow-hidden">
                <Dropdown
                    inputId="relative_date_unit"
                    v-model="userGroupModel.relative_date_unit"
                    :options="getRelativeDates()"
                    @change="needRefresh = true"
                    placeholder="Select relative date type"
                    optionLabel="name"
                    optionValue="code"
                    class="flex-grow-1 flex-shrink-1 flex "
                    :disabled="readonly === true || userGroupModel.date_from!==null || userGroupModel.date_to!==null"
                />
                    <Button
                        icon="pi pi-times"
                        text
                        raised
                        rounded

                        aria-label="Cancel"
                        class="ml-1 flex-shrink-0 flex  p-button-info"
                        :disabled="readonly || userGroupModel.date_from!==null || userGroupModel.date_to!==null"
                        @click="userGroupModel.relative_date_unit = null"
                    />
                </div>
                <small
                    v-if="userGroupModel.date_from!==null || userGroupModel.date_to!==null"
                    class="p-invalid">
                    Disabled because of Date From or Date To
                </small>
                <small
                    v-if="userGroupModel.relative_date_unit===null && userGroupModel.relative_date_qty!==null"
                    class="p-error">
                    Please select a type and a quantity.
                </small>
            </div>

            <div class="form-field col-3">
                <label for="relative_date_unit">Relative Date quantity</label>
                <div class="flex overflow-hidden">
                    <InputNumber
                        v-model="userGroupModel.relative_date_qty"
                        inputId="relative_date_unit"
                        @input="needRefresh = true"
                        class="flex-grow-1 flex-shrink-1 flex "
                        :disabled="readonly || userGroupModel.date_from!==null || userGroupModel.date_to!==null"
                    />
                    <Button
                        icon="pi pi-times"
                        text
                        raised
                        rounded
                        aria-label="Cancel"
                        class="ml-1 flex-shrink-0 flex  p-button-info"
                        :disabled="readonly || userGroupModel.date_from!==null || userGroupModel.date_to!==null"
                        @click="userGroupModel.relative_date_qty = null"
                    />
                </div>
                <small
                    v-if="userGroupModel.date_from!==null || userGroupModel.date_to!==null"
                    class="p-invalid">
                    Disabled because of Date From or Date To
                </small>
                <small
                    v-if="userGroupModel.relative_date_unit!==null && userGroupModel.relative_date_qty===null"
                    class="p-error">
                    Please select a type and a quantity.
                </small>
            </div>

            <div class="form-field col-3">
                <label for="date_from">Date From:</label>
                <div class="flex overflow-hidden">
                    <Calendar
                        id="date_from"
                        :manualInput="true"
                        :showIcon="true"
                        :showButtonBar="true"
                        @update:modelValue="needRefresh = true"
                        dateFormat="dd-mm-yy"
                        class="flex-grow-1 flex-shrink-1 flex "
                        v-model="userGroupModel.date_from"
                        :disabled="readonly || userGroupModel.relative_date_unit || userGroupModel.relative_date_qty"
                    />
                    <Button
                        icon="pi pi-times"
                        text
                        raised
                        rounded
                        aria-label="Cancel"
                        class="ml-1 flex-shrink-0 flex  p-button-info"
                        :disabled="readonly || userGroupModel.relative_date_unit || userGroupModel.relative_date_qty"
                        @click="userGroupModel.date_from = null"
                    />
                </div>
                <small
                    v-if="userGroupModel.relative_date_unit || userGroupModel.relative_date_qty"
                    class="p-invalid">
                    Disabled because of Relative Date
                </small>
            </div>

            <div class="form-field col-3">
                <label for="date_to">Date To:</label>
                <div class="flex overflow-hidden">
                    <Calendar
                        id="date_to"
                        :showIcon="true"
                        :manualInput="true"
                        :showButtonBar="true"
                        dateFormat="dd-mm-yy"
                        @update:modelValue="needRefresh = true"
                        v-model="userGroupModel.date_to"
                        :disabled="readonly || userGroupModel.relative_date_unit || userGroupModel.relative_date_qty"
                        class="flex-grow-1 flex-shrink-1 flex "
                    />
                    <Button
                        icon="pi pi-times"
                        text
                        raised
                        rounded
                        aria-label="Cancel"
                        class="ml-1 flex-shrink-0 flex  p-button-info"
                        :disabled="readonly || userGroupModel.relative_date_unit || userGroupModel.relative_date_qty"
                        @click="userGroupModel.date_to = null"
                    />
                </div>
                <small
                    v-if="userGroupModel.relative_date_unit || userGroupModel.relative_date_qty"
                    class="p-invalid">
                    Disabled because of Relative Date
                </small>
            </div>

            <div class="form-field col-3">
                <label for="relative_date_unit">Assessment</label>
                <Dropdown
                    inputId="relative_date_unit"
                    v-model="userGroupModel.assessment_code"
                    :options="assessmentList"
                    :loading="assessmentLoading"
                    @change="needRefresh = true"
                    placeholder="Select the assessment"
                    optionLabel="name"
                    optionValue="code"
                    :disabled="readonly"
                    class="flex-grow-1 flex-shrink-1 flex "
                />
            </div>

            <div class="form-field col-3">
                <label>Target Users:</label>
                <div class="flex overflow-hidden">
                    <Button
                        :label="targetUserGroup.name ?? 'None'"
                        text
                        raised
                        rounded
                        :disabled="readonly"
                        :loading="targetUserGroupLoading"
                        aria-label="Cancel"
                        class="flex-grow-1 flex-shrink-1 flex "
                        @click="showUserGroupPopup(targetUserGroup.id, 'Target Users:', 'target')"
                    />
                    <Button
                        icon="pi pi-user"
                        label="Users"
                        :badge="targetUserGroup.users.length.toString()"
                        text
                        raised
                        rounded
                        :loading="targetUserGroupLoading"
                        aria-label="Cancel"
                        class="ml-1 flex-shrink-0 flex  p-button-info"
                        @click="showTargetUserList"
                    />
                    <Button
                        icon="pi pi-times"
                        text
                        raised
                        rounded
                        :disabled="readonly"
                        :loading="targetUserGroupLoading"
                        aria-label="Cancel"
                        class="ml-1 flex-shrink-0 flex  p-button-info"
                        @click="resetTargetUserGroup"
                    />
                </div>
            </div>

            <div class="form-field col-3">
                <label for="date_to">Excluded users:</label>
                <div class="flex overflow-hidden">
                    <Button
                        :label="excludedUserGroup.name ?? 'None'"
                        text
                        raised
                        rounded
                        :disabled="readonly"
                        :loading="excludedUserGroupLoading"
                        aria-label="Cancel"
                        class="flex-grow-1 flex-shrink-1 flex "
                        @click="showUserGroupPopup(excludedUserGroup.id, 'Excluded users:', 'excluded')"
                    />
                    <Button
                        icon="pi pi-user"
                        label="Users"
                        :badge="excludedUserGroup.users.length.toString()"
                        text
                        raised
                        rounded
                        :loading="excludedUserGroupLoading"
                        aria-label="Cancel"
                        class="ml-1 flex-shrink-0 flex  p-button-info"
                        @click="showExcludedUserList"
                    />
                    <Button
                        icon="pi pi-times"
                        text
                        raised
                        rounded
                        :disabled="readonly"
                        :loading="excludedUserGroupLoading"
                        aria-label="Cancel"
                        class="ml-1 flex-shrink-0 flex  p-button-info"
                        @click="resetExcludedUserGroup"
                    />
                </div>
            </div>

            <div class="col-12">
                <div class="flex justify-content-between flex-wrap">
                    <div class="flex justify-content-start mt-2">
                        <small v-if="needRefresh">
                            To see the updated list of User below, please use the <b>Update</b> button.
                        </small>
                    </div>
                    <div class="flex justify-content-end">
                        <Button label="Cancel" icon="pi pi-times" class="p-button-danger" @click="onCancel" />
                        <Button :disabled="readonly || saving || formIsInvalid" label="Update" icon="pi pi-refresh" class="ml-2 p-button-primary" @click="onUpdate" />
                        <Button :disabled="readonly || saving || formIsInvalid" label="Submit" icon="pi pi-check" class="ml-2 p-button-success" @click="onSubmit" />
                    </div>
                </div>
            </div>
        </div>

    </div>

    <div v-if="!loading"  class="card">

        <div class="flex justify-content-center flex-wrap">
            <div class="flex align-items-center justify-content-center m-2">
                Users members of &nbsp; <b>{{userGroupModel.name}}</b>
            </div>
        </div>

        <DataTable
            :value="userGroupModel.users"
            :loading="loadingUserList"
            :paginator="true"
            :rows="10"
            :rowsPerPageOptions="[5, 10, 20, 50]"
            responsiveLayout="scroll">
            <template #empty> No Users available </template>
            <Column field="id" header="ID" />
            <Column field="name" header="Name" />
            <Column field="surname" header="Surname" />
        </DataTable>
    </div>

    <Dialog v-model:visible="showTargetUsersWindows" modal>
        <template #header>
            <div class="inline-flex align-items-center justify-content-center gap-2">
                <span class=" white-space-nowrap">Members of UserGroup: <b>{{targetUserGroup.name}}</b></span>
            </div>
        </template>

        <DataTable :value="targetUserGroup.users" :paginator="true" :rows="5" responsiveLayout="scroll">
            <template #empty> No Users available </template>
            <Column field="id" header="ID" />
            <Column field="name" header="Name" />
            <Column field="surname" header="Surname" />
        </DataTable>
    </Dialog>

    <Dialog v-model:visible="showExcludedUsersWindows" modal>
        <template #header>
            <div class="inline-flex align-items-center justify-content-center gap-2">
                <span class=" white-space-nowrap">Members of UserGroup: <b>{{excludedUserGroup.name}}</b></span>
            </div>
        </template>

        <DataTable :value="excludedUserGroup.users" :paginator="true" :rows="5" responsiveLayout="scroll">
            <template #empty> No Users available </template>
            <Column field="id" header="ID" />
            <Column field="name" header="Name" />
            <Column field="surname" header="Surname" />
        </DataTable>
    </Dialog>

    <Dialog v-model:visible="showTargetUserGroupWindow" modal>
        <template #header>
            <div class="inline-flex align-items-center justify-content-center gap-2">
                <span class=" white-space-nowrap"><b>{{userGroupWindowsTitle}}</b></span>
            </div>
        </template>
        <template #footer>
            <small>To select to desiderata User Group, use the button on the left.</small>
        </template>

        <DataTable
            :value="userGroups"
            :paginator="true"
            :lazy="true"
            :rowHover="true"
            @page="onPage"
            dataKey="id"
            :totalRecords="totalRecords"
            :rows="5"
            responsiveLayout="scroll"
            :loading="userGroupLoading"
        >
            <template #empty> No Users available </template>
            <Column v-if="userGroupWindowsType === 'target'" header="Select">
                <template #body="slotProps">
                    <Button
                        v-if="userGroupWindowSelectedUserGroup === null ||  slotProps.data.id.toString() !== userGroupWindowSelectedUserGroup.toString()"
                        icon="pi pi-check"
                        class="p-button-rounded p-button-info mr-2"
                        aria-label="Select this one"
                        @click="selectTargetUserGroup(slotProps.data.id, slotProps.data.name, slotProps.data.users)"
                    />
                    <i v-else class="pi pi-check ml-2" style="color: green; font-size: 1.5rem"></i>

                </template>
            </Column>
            <Column v-else-if="userGroupWindowsType === 'excluded'" header="Select">
                <template #body="slotProps">

                    <Button
                        v-if="userGroupWindowSelectedUserGroup === null ||  slotProps.data.id.toString() !== userGroupWindowSelectedUserGroup.toString()"
                        icon="pi pi-check"
                        class="p-button-rounded p-button-info mr-2"
                        aria-label="Select this one"
                        @click="selectExcludedUserGroup(slotProps.data.id, slotProps.data.name, slotProps.data.users)"
                    />
                    <i v-else class="pi pi-check ml-2" style="color: green; font-size: 1.5rem"></i>

                </template>
            </Column>
            <Column field="id" header="Id" />
            <Column field="name" header="Name" />
            <Column field="description" header="Description" />
            <Column field="users" header="Users" ref="users" key="userGroup.id" style="width: 2rem" >
                <template #body="slotProps">
                    <Button
                        icon="pi pi-user"
                        label="Users"
                        :badge="slotProps.data.users.length.toString()"
                        class="m-2 p-button p-button-warning"
                        v-tooltip="'Show User Group members'"
                        @click="toggleUserGroupMemberWindows(slotProps.data.users, slotProps.data.name)" />
                </template>
            </Column>
        </DataTable>
    </Dialog>

    <Dialog v-model:visible="userGroupWindowsShow" modal>
        <template #header>
            <div class="inline-flex align-items-center justify-content-center gap-2">
                <span class=" white-space-nowrap">Members of UserGroup: <b>{{userGroupWindowsGroupName}}</b></span>
            </div>
        </template>

        <DataTable :value="userGroupWindowsMembers" :paginator="true" :rows="5" responsiveLayout="scroll">
            <template #empty> No Users available </template>
            <Column field="id" header="ID" />
            <Column field="name" header="Name" />
            <Column field="surname" header="Surname" />
        </DataTable>
    </Dialog>
</template>

<script setup>
import { computed, defineProps, onBeforeMount, ref } from 'vue';
import GlobalRequest from '@/api/global-request';
import store from '@/store';
import { useRouter } from 'vue-router';
import { showToast } from '@/helpers/toast-handler';
import { DateTime } from 'luxon';

const router = useRouter();

const loading = ref(true);
const assessmentList = ref([]);
const assessmentLoading = ref(true)

const showTargetUsersWindows = ref(false)
const targetUserGroupLoading = ref(false)

const targetUserGroup = ref({
    id: null,
    name: null,
    users:[]
})

const showExcludedUsersWindows = ref(false)
const excludedUserGroupLoading = ref(false)

const showTargetUserGroupWindow = ref(false)

const excludedUserGroup = ref({
    id: null,
    name: null,
    users:[]
})

const totalRecords = ref(0);
const paginationRows = ref(10)
const paginationPage = ref(1)
const userGroups = ref([])
const userGroupLoading = ref(false)
const userGroupWindowsTitle = ref('')
const userGroupWindowsType = ref(null)
const userGroupWindowSelectedUserGroup = ref(null)

const userGroupWindowsShow = ref(false)
const userGroupWindowsGroupName = ref('')
const userGroupWindowsMembers = ref([])

const loadingUserList = ref(false)

const needRefresh = ref(false)

const props = defineProps({
    id: {
        type: [String, Number],
        required: false,
    }
});

const company_id = computed(() => {
    return store.getters['auth/userCompanyId']?.id;
});

const readonly = computed(() => {
    return router.currentRoute.value.meta.readonly ?? false
});

const formIsInvalid = computed(() => {
    if (!userGroupModel.value.name) {
        return true
    }
    if (userGroupModel.value.relative_date_qty && !userGroupModel.value.relative_date_unit) {
        return true
    }
    if (!userGroupModel.value.relative_date_qty && userGroupModel.value.relative_date_unit) {
        return true
    }
    if (!userGroupModel.value.assessment_code) {
        return true
    }

    return false
});

const userGroupModel = ref({
    id: null,
    name: null,
    code: null,
    description: null,
    relative_date_unit: null,
    relative_date_qty: null,
    date_from: null,
    date_to: null,
    assessment_code: null,
    company_id: null,
    target_user_group_id: null,
    excluded_user_group_id: null,
    type: null,
    users: [],
})

//const users = ref([]);

function onCancel() {
    router.go(-1)
}

const saving = ref(false);

function formatRequestPayload(data) {

    if (data.date_from) data.date_from = DateTime.fromJSDate(data.date_from).setLocale('en-GB').toFormat('yyyy-MM-dd')
    if (data.date_to) data.date_to = DateTime.fromJSDate(data.date_to).setLocale('en-GB').toFormat('yyyy-MM-dd')

    let output = {
        'company_id': company_id.value,
        'name': data.name,
        'description': data.description,
        'date_from': data.date_from,
        'date_to': data.date_to,
        'assessment_code': data.assessment_code,
        'target_user_group_id': data.target_user_group_id,
        'excluded_user_group_id': data.excluded_user_group_id,
        'type': 'NOT_TESTED',
    }

    if (Object.hasOwn(data, 'relative_date_unit') || Object.hasOwn(data, 'relative_date_qty')) {
        output.relative_date = {
            'unit': data.relative_date_unit,
            'quantity': data.relative_date_qty,
        }
    }

    return output
}

function onUpdate() {
    needRefresh.value = false
    saving.value = true
    loadingUserList.value = true


    if (typeof userGroupModel.value.id !== 'undefined' && userGroupModel.value.id > 0) {
        // update
        GlobalRequest.patchRequest(`/v2/datasource/special/user/group/${userGroupModel.value.id}`, formatRequestPayload(userGroupModel.value)).then((response) => {
            if (response.statusCode === 200) {
                saving.value = false;
                loadingUserList.value = false;
                userGroupModel.value.users = response.data.users

            }
        });
    } else {
        // create
        GlobalRequest.postRequest(`/v2/datasource/special/user/group`, formatRequestPayload(userGroupModel.value)).then((response) => {
            if (response.statusCode === 201) {
                saving.value = false;
                loadingUserList.value = false;
                userGroupModel.value.users = response.data.users

            }
        });
    }
}

function onSubmit() {
    saving.value = true

    if (typeof userGroupModel.value.id !== 'undefined' && userGroupModel.value.id > 0) {
        // update
        GlobalRequest.patchRequest(`/v2/datasource/special/user/group/${userGroupModel.value.id}`, formatRequestPayload(userGroupModel.value)).then((response) => {
            if (response.statusCode === 200) {
                saving.value = false;
                router.go(-1)
            }
        });
    } else {
        // create
        GlobalRequest.postRequest(`/v2/datasource/special/user/group`, formatRequestPayload(userGroupModel.value)).then((response) => {
            if (response.statusCode === 201) {
                saving.value = false;
                router.go(-1)
            }
        });
    }
}

function getRelativeDates() {
    return [
        { name: 'Year', code: 'year' },
        { name: 'Month', code: 'month' },
        { name: 'Week', code: 'week' },
        { name: 'Day', code: 'day' },
    ]
}

function loadAssessments() {
    assessmentList.value = []
    assessmentLoading.value = true

    GlobalRequest.getRequest(`/v2/template/assessment`, {
        params: {
            company_id: company_id.value,
            default: true,
            no_user_profile: true,
        },
    }).then((response) => {
        if (response.statusCode === 200) {
            if (Object.hasOwn(response, 'data')) {


                response.data.forEach((assessment) => {
                    assessmentList.value.push({
                        code: assessment.code,
                        name: assessment.name,
                    })
                })

                assessmentLoading.value = false
            }
        }
    })

}

function loadUserGroupDetails(userGroupId) {
    loading.value = true;
    targetUserGroupLoading.value = true;
    excludedUserGroupLoading.value = true;

    GlobalRequest.getRequest(`/v2/datasource/special/user/group/${userGroupId}`, {
        params: {
            company_id: company_id.value,
        },
    }).then((response) => {
        if (response.statusCode === 200) {
            if (Object.hasOwn(response, 'data')) {

                if (Object.hasOwn(response.data, 'data')) {


                    const data = response.data.data

                    if (Object.hasOwn(data, 'id')) {
                        userGroupModel.value.id = data.id
                    }
                    if (Object.hasOwn(data, 'assessment_code')) {
                        userGroupModel.value.assessment_code = data.assessment_code
                    }
                    if (Object.hasOwn(data, 'company_id')) {
                        userGroupModel.value.company_id = data.company_id
                    }
                    if (Object.hasOwn(data, 'date_from')) {
                        if (data.date_from !== null) {
                            userGroupModel.value.date_from = DateTime.fromISO(data.date_from).setLocale('en-GB').toJSDate()
                        }
                    }
                    if (Object.hasOwn(data, 'date_to')) {
                        if (data.date_to !== null) {
                            userGroupModel.value.date_to = DateTime.fromISO(data.date_to).setLocale('en-GB').toJSDate()
                        }
                    }
                    if (Object.hasOwn(data, 'code')) {
                        userGroupModel.value.code = data.code
                    }
                    if (Object.hasOwn(data, 'description')) {
                        userGroupModel.value.description = data.description
                    }
                    if (Object.hasOwn(data, 'excluded_user_group_id')) {
                        userGroupModel.value.excluded_user_group_id = data.excluded_user_group_id
                    }
                    if (Object.hasOwn(data, 'name')) {
                        userGroupModel.value.name = data.name
                    }
                    if (Object.hasOwn(data, 'relative_date_qty')) {
                        userGroupModel.value.relative_date_qty = data.relative_date_qty
                    }
                    if (Object.hasOwn(data, 'relative_date_unit')) {
                        userGroupModel.value.relative_date_unit = data.relative_date_unit
                    }
                    if (Object.hasOwn(data, 'target_user_group_id')) {
                        userGroupModel.value.target_user_group_id = data.target_user_group_id
                    }
                    if (Object.hasOwn(data, 'type')) {
                        userGroupModel.value.type = data.type
                    }
                    if (Object.hasOwn(data, 'target_user_group_id')) {
                        userGroupModel.value.target_user_group_id = data.target_user_group_id

                        targetUserGroup.value.id = null
                        targetUserGroup.value.name = null
                        targetUserGroup.value.users = []

                        if (data.target_user_group_id > 0) {
                            targetUserGroup.value.id = data.target_user_group_id
                            GlobalRequest.getRequest(`/v2/datasource/users/${data.target_user_group_id}`, {
                                params: {
                                    company_id: company_id.value,
                                },
                            }).then((response) => {
                                if (response.statusCode === 200) {
                                    if (Object.hasOwn(response, 'data')) {


                                        if (Object.hasOwn(response.data, 'userGroup')) {

                                            targetUserGroup.value.name = response.data.userGroup.name
                                        }

                                        if (Object.hasOwn(response.data, 'users')) {

                                            targetUserGroup.value.users = response.data.users
                                        }

                                        targetUserGroupLoading.value = false;
                                    }
                                }
                            })
                        } else {
                            targetUserGroupLoading.value = false;
                        }

                        if (data.excluded_user_group_id > 0) {
                            excludedUserGroup.value.id = data.excluded_user_group_id
                            GlobalRequest.getRequest(`/v2/datasource/users/${data.excluded_user_group_id}`, {
                                params: {
                                    company_id: company_id.value,
                                },
                            }).then((response) => {
                                if (response.statusCode === 200) {
                                    if (Object.hasOwn(response, 'data')) {

                                        if (Object.hasOwn(response.data, 'userGroup')) {
                                            excludedUserGroup.value.name = response.data.userGroup.name
                                        }

                                        if (Object.hasOwn(response.data, 'users')) {

                                            excludedUserGroup.value.users = response.data.users
                                        }

                                        excludedUserGroupLoading.value = false;
                                    }
                                }
                            })
                        } else {
                            excludedUserGroupLoading.value = false;
                        }
                    }

                    //userGroupModel
                }
                if (Object.hasOwn(response.data, 'users')) {
                    userGroupModel.value.users = response.data.users
                }

                //  userGroupModel

                loading.value = false;
            }
        }
    }).catch((response) => {
        showToast(response, response.data.message);
        console.error('something went wrong:', response, userGroupId);
    });
}

onBeforeMount( () => {
    if (props.id !== undefined) {
        loadUserGroupDetails(props.id)
    } else {
        loading.value = false;
    }

    loadAssessments()
});

function resetTargetUserGroup() {
    targetUserGroup.value.id = null
    targetUserGroup.value.name = null
    targetUserGroup.value.users = []
    userGroupModel.value.target_user_group_id = null
    needRefresh.value = true
}

function selectTargetUserGroup(id, name, users) {
    targetUserGroup.value.id = id
    targetUserGroup.value.name = name
    targetUserGroup.value.users = users
    userGroupModel.value.target_user_group_id = id
    showTargetUserGroupWindow.value = false
    needRefresh.value = true
}

function resetExcludedUserGroup() {
    excludedUserGroup.value.id = null
    excludedUserGroup.value.name = null
    excludedUserGroup.value.users = []
    userGroupModel.value.excluded_user_group_id = null
    needRefresh.value = true
}

function selectExcludedUserGroup(id, name, users) {
    excludedUserGroup.value.id = id
    excludedUserGroup.value.name = name
    excludedUserGroup.value.users = users
    userGroupModel.value.excluded_user_group_id = id
    showTargetUserGroupWindow.value = false
    needRefresh.value = true
}

function showTargetUserList() {
    showTargetUsersWindows.value = true
}

function showExcludedUserList() {
    showExcludedUsersWindows.value = true
}

function showUserGroupPopup(selectedUserGroup, label, type) {

    paginationPage.value = 1
    userGroups.value = []
    loadUserGroup()
    showTargetUserGroupWindow.value = true

    userGroupWindowsTitle.value = label

    userGroupWindowSelectedUserGroup.value = selectedUserGroup

    userGroupWindowsType.value = type
}

const onPage = async (event) => {
    paginationRows.value = event.rows;
    //Table data pages start with 0 not with 1.
    paginationPage.value = event.page + 1;

    loadUserGroup();
};

function loadUserGroup() {
    userGroupLoading.value = true;
    GlobalRequest.getRequest('v2/datasource/users', {
        params: {
            company_id: company_id.value,
            page_size: paginationRows.value,
            page: paginationPage.value,
            paginate: true,
            execute: true,
        },
    }).then((response) => {
        userGroups.value = response.data.data;
        totalRecords.value = response.data.total
    }).then(() => {
        userGroupLoading.value = false;
    });
}

function toggleUserGroupMemberWindows(users, userGroupName) {
    userGroupWindowsShow.value = true;
    userGroupWindowsGroupName.value = userGroupName;
    userGroupWindowsMembers.value = users;
}

</script>

<style lang="scss" scoped>
.form-field {
    display: flex;
    flex-direction: column;
    margin-bottom: 0.5rem;
}

.form-field label {
    margin-bottom: 0.5rem;
}
</style>